export const customersNavigation = [
    {
        text: 'Customers',
        icon: 'group',
        path: '/customers'
    }
];
